import { render, staticRenderFns } from "./cuentas.vue?vue&type=template&id=03bf141b&scoped=true"
import script from "./cuentas.vue?vue&type=script&lang=js"
export * from "./cuentas.vue?vue&type=script&lang=js"
import style0 from "./cuentas.vue?vue&type=style&index=0&id=03bf141b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf141b",
  null
  
)

export default component.exports